<template>
  <layout-main>
    <splitpanes class="default-theme h-full" :push-other-panes="false" @resize="onResizeList">
      <pane v-if="layout.isListFullHeight" :size="layout.listPanelSize">
        <slot name="listPanel" />
      </pane>
      <pane :size="layout.combinedPanelSize">
        <splitpanes :push-other-panes="false" horizontal @resize="onResizeTable">
          <pane :size="layout.viewPanelSize">
            <splitpanes v-if="!layout.isListFullHeight" :push-other-panes="false" @resize="onResizeView">
              <pane v-if="!layout.isListFullHeight" :size="layout.listPanelSize">
                <slot name="listPanel" />
              </pane>
              <pane class="relative">
                <slot name="viewPanel" />
              </pane>
            </splitpanes>
            <div v-else class="relative h-full">
              <slot name="viewPanel" />
            </div>
          </pane>
          <pane :size="layout.tablePanelSize">
            <slot name="tablePanel" />
          </pane>
        </splitpanes>
      </pane>
    </splitpanes>

    <template #navbar>
      <div class="isolate flex rounded-md shadow-sm">
        <button
          type="button"
          class="btn-flat rounded-r-none text-gray-600"
          :class="{ 'bg-primary-100 text-primary-700 ring-primary-400 pointer-events-none': layout.isListFullHeight }"
          @click="layout.isListFullHeight = true"
        >
          <Collage :size="20" class="h-5 w-5" aria-hidden="true" />
        </button>
        <button
          type="button"
          class="-ml-px btn-flat rounded-l-none text-gray-600"
          :class="{ 'bg-primary-100 text-primary-700 ring-primary-400 pointer-events-none': !layout.isListFullHeight }"
          @click="layout.isListFullHeight = false"
        >
          <Collage :size="20" class="h-5 w-5 -rotate-90" aria-hidden="true" />
        </button>
      </div>
    </template>
  </layout-main>
</template>

<script setup>
import LayoutMain from './LayoutMain.vue';
import { Splitpanes, Pane } from 'splitpanes';
import Collage from 'vue-material-design-icons/Collage.vue';
import { layout } from '../composables/useLayoutGrid';

// function toggleLayout() {
//   layout.value.isListFullHeight = !layout.value.isListFullHeight;
// }

function onResizeList($event) {
  layout.value.listPanelSize = $event.panes[0].size;
  layout.value.combinedPanelSize = $event.panes[1].size;
}

function onResizeTable($event) {
  layout.value.viewPanelSize = $event.panes[0].size;
  layout.value.tablePanelSize = $event.panes[1].size;
}

function onResizeView($event) {
  layout.value.listPanelSize = $event.panes[0].size;
  // layout.value.combinedPanelSize = 100 - $event.panes[0].size;
}
</script>
